import {createAction, props} from '@ngrx/store';

import {
  SystemUser,
  SystemUserFiltering
} from './system-user.model';
import {Update} from "@ngrx/entity";

export const loadSystemUsers = createAction(
  '[SystemUser/API] Load SystemUsers',
  props<{ systemUsers: SystemUser[] }>()
);

export const addSystemUser = createAction(
  '[SystemUser/API] Add SystemUser ',
  props<{ systemUser: SystemUser }>()
);

export const upsertSystemUser = createAction(
  '[SystemUser/API] Upsert SystemUser ',
  props<{ systemUser: SystemUser }>()
);

export const addSystemUsers = createAction(
  '[SystemUser/API] Add SystemUsers',
  props<{ systemUsers: SystemUser[] }>()
);

export const upsertSystemUsers = createAction(
  '[SystemUser/API] Upsert SystemUsers',
  props<{ systemUsers: SystemUser[] }>()
);

export const updateSystemUser = createAction(
  '[SystemUser/API] Update SystemUser ',
  props<{ systemUser: Update<SystemUser> }>()
);

export const updateSystemUsers = createAction(
  '[SystemUser/API] Update SystemUsers',
  props<{ systemUsers: Update<SystemUser>[] }>()
);

export const deleteSystemUser = createAction(
  '[SystemUser/API] Delete SystemUser ',
  props<{ id: number }>()
);

export const deleteSystemUsers = createAction(
  '[SystemUser/API] Delete SystemUsers',
  props<{ ids: string[] }>()
);

export const clearSystemUsers = createAction(
  '[SystemUser/API] Clear SystemUsers'
);

// Effects actions

export const getAllSystemUsers = createAction(
  '[SystemUser/API] get All System Users'
);

